<template>
  <el-card
    id="actionPlanCard"
    v-loading="loading"
    class="clear-card actionPlan"
    :class="['mobile','tablet'].includes($mq) ? 'mobile' : 'desktop'"
    shadow="hover"
    :body-style="{
      height: 'calc(100% - 95px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
    }"
  >
    <div
      slot="header"
      class="clearfix title"
    >
      <span>{{ $t('aside.actionPlan') }}</span>
    </div>
    <div
      class="content"
      :class="actionPlan.length > 0 ? 'filledData' : ''"
    >
      <div
        v-if="actionPlan.length > 0"
        class="charts"
      >
        <OverviewChart
          :chart-data="actionPlan"
          type-display="small"
        />

        <span class="viewDetailsBtn">
          <el-button
            class="detailsBtn"
            round
            :loading="viewLoading"
            :disabled="session < 4"
            @click="toggleDetail"
          >
            {{ $t('settings.viewDetails') }}
          </el-button>
        </span>
      </div>
      <div
        v-else
        class="no-data defaultCursor"
      >
        {{ $t('actionPlan.notOpenedYet') }}

        <div class="draftBtnWrap">
          <el-button
            class="clearBtn"
            type="plain"
            round
            @click="openDraft"
          >
            {{ $t('common.draft') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  components: {
    OverviewChart: () => import(/* webpackChunkName: "Charts" */ '@/views/dashboard/content/leader/actionPlan/overview/OverviewChart.vue'),
  },

  props: {
    leaderUuid: {
      type: String,
      default: '',
    },

    session: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      actionPlan: [],
      loading: false,
      viewLoading: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  watch: {
    leaderUuid() {
      // trigger session status update when navigate from leader to leader from leader alert
      this.getLeaderDetails();
    },
  },

  created() {
    this.getLeaderDetails();
  },

  methods: {
    async getLeaderDetails() {
      try {
        this.loading = true;
        let response;
        if (this.user.user.role_type) {
          response = await api.getCoachLeaderAP(this.leaderUuid);

          this.actionPlan = response.data;
        } else {
          this.actionPlan = [];
        }
      } catch (err) {
        console.log(err);
        // if (err.msg) {
        //   this.$message.error(`${err.msg} Action plan`);
        // }
        this.actionPlan = [];
      } finally {
        this.loading = false;
      }
    },

    toggleDetail() {
      this.viewLoading = true;

      // Without set-timeout, flag not working.
      setTimeout(() => {
        this.$router.push({
          name: 'myLeaderActionPlan',
          params: { id: this.leaderUuid },
        }).catch((err) => {});
      }, 1);
    },

    openDraft() {
      this.$router.push({
        name: 'myLeaderActionPlanSetUp',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #actionPlanCard {
    height: 100%;
    min-height: 154px;

    .title {
      text-align: center;
      position: relative;
    }

    &:not(.mobile):not(.tablet) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-style: italic;
      text-align: center;
      color: #c4c4c4;

      &.filledData {
        margin-left: -20px;
      }

      .viewDetailsBtn {
        margin: 0 0 0 20px;

        .detailsBtn {
          background-color: transparent;
          color: var(--themeFontColor);

          &.is-disabled {
            opacity: 0.5;
          }
        }
      }

      .no-data {
        font-style: italic;
        color: #c4c4c4;
      }
    }

    .clearBtn {
      padding: 12px 15px;
      margin-top: 15px;
      width: 100%;
      max-width: 130px;
      background-color: transparent;
      word-break: break-word;
      white-space: normal;
      color: var(--themeFontColor);
      border-color: var(--themeFontColor);

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }
</style>

<style lang="scss">
  #actionPlanCard {
    .el-card__header {
      font-weight: bold;
    }

    &.mobile,
    &.tablet {
      .el-card__header {
        border-bottom: 0;
      }
    }
  }
</style>
